import { Configuration } from "@azure/msal-browser";
import {
  authority,
  clientId,
  authorityProd,
  clientIdProd,
} from "../../config/env";
const hostUrl = globalThis.location.origin;

export const msalConfig: Configuration = {
  auth: {
    clientId: `${hostUrl === process.env.REACT_APP_URL_PROD ? clientIdProd : clientId}`,
    authority: `${hostUrl === process.env.REACT_APP_URL_PROD ? authorityProd : authority}`,
    redirectUri: `${hostUrl}/auth/callback`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_level, _message, containsPii) => {
        if (containsPii) {
          return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [],
};
